import React, { useContext, useState, useEffect } from 'react';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import FilterCtx from '../../../../context/filterContext/filterCtx';
import { Switch } from '@progress/kendo-react-inputs';
import { getPeriods } from '../../../../common/services/http/documentsService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

import '../../dropdown/dropdown.scss';
import '../filters.scss';

const defaultPeriod = {
  name: 'Period',
  endDate: null,
  periodNumber: null,
  startDate: null,
  year: null,
};

interface Periods {
  periodsState?: string;
  toggleOn?: boolean;
}

const PeriodsFilter: React.FC<Periods> = ({ toggleOn }) => {
  const filterCtx: any = useContext(FilterCtx);
  const [value, setValue] = useState<any>(null);
  const [checked, setChecked] = useState(false);
  const [periods, setPeriods] = useState([]);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    setChecked(filterCtx.slicerChoices.indexOf('period') + 1 > 0);
    getPeriods(3).then((res) => {
      let tempPeriods = [];
      res.data.forEach((period) => {
        tempPeriods.push(period);
      });
      setPeriods(tempPeriods);
    });

    if (filterCtx.period) {
      setValue(filterCtx.period);
    }
  }, [impersonation]);

  useEffect(() => {
    filterCtx.setPeriod(value);
  }, [value]);

  const handlePeriodToggleChange = (e): void => {
    setChecked(e.value);
    filterCtx.setPeriodToggle(e.value);
    filterCtx.setPeriod('');
    setValue(null);
    let tempArray = filterCtx.slicerChoices;
    let tempGroupsArray = filterCtx.initialGroup;
    if (e.value) {
      filterCtx.setSlicerChoices([...filterCtx.slicerChoices, 'period']);
      filterCtx.setInitialGroup([...filterCtx.initialGroup, { field: 'period' }]);
    } else {
      tempArray = filterCtx.slicerChoices.filter((item) => item !== 'period');
      tempGroupsArray = filterCtx.initialGroup.filter((item) => item.field !== 'period');
      filterCtx.setSlicerChoices(tempArray);
      filterCtx.setInitialGroup(tempGroupsArray);
    }
  };

  const handlePeriodChange = (event: DropDownListChangeEvent): void => {
    setValue(event.value && event.value);
  };

  return (
    <div className="periods-filter-wrapper">
      <DropDownList
        className={toggleOn && checked ? 'multiselect-padding-left' : ''}
        data={periods}
        defaultValue={value ? value : defaultPeriod}
        defaultItem={defaultPeriod}
        textField="name"
        dataItemKey="startDate"
        disabled={toggleOn && checked}
        onChange={handlePeriodChange}
      />
      {toggleOn && checked && filterCtx.slicerChoices.indexOf('period') + 1 > 0 && (
        <div className="switch-number-container">
          <span>{filterCtx.slicerChoices.indexOf('period') + 1}</span>
        </div>
      )}
      {toggleOn && (
        <div className="switch-container">
          <Switch onLabel={''} offLabel={''} checked={checked} onChange={handlePeriodToggleChange} />
        </div>
      )}
    </div>
  );
};

export default PeriodsFilter;
